import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import tmdbApi from "../../../api/tmdbApi";
import 'react-time-picker/dist/TimePicker.css';
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import axios from "axios";
import DateTimeRangePicker from "../../../components/DateTimeRangePicker";
import DateTimeRangePicker24Hr from "../../../components/MeetingDateTimeRangePicker";
import dayjs from 'dayjs';
import Modal from 'react-bootstrap/Modal';
import ParticipantTable from "../../../components/ParticipantTable";
import Editor from 'react-simple-wysiwyg';

import rotate_right from "../../../assets/images/rotate_right.svg";
import Loader from "../../../components/loader";

const isValidTime = (value) => /^([01]\d|2[0-3]):([0-5]\d)$/.test(value);

const CPCForm = ({ id, upcoming, setAnnounce, setnavigatePage, handleClick, cpcInfoRes }) => {
    const navigate = useNavigate();
    const [resultData, setResultData] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingBtn, setIsLoadingBtn] = useState("");
    const [selectedCases, setSelectedCases] = useState([]);
    const [activeCPC, setActiveCPC] = useState(cpcInfoRes?.lenth > 0 ? true : false ?? true);
    const [cases, setCases] = useState([]);
    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState(false);
    const [submitStatus, setSubmitStatus] = useState('');
    const [filterType, setFilterType] = useState("");
    const [isCpcInProcess, setIsCpcInProcess] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const [isSendingMail, setIsSendingMail] = useState(false);
    const [mailStatus, setMailStatus] = useState('');
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false); // ✅ NEW: Track if data is fully loaded

    const [formData, setFormData] = useState({
        title: '',
        meetingLink: '',
        scheduleDate: '',
        scheduleEndDate: '',
        scheduleStartTime: '',
        scheduleEndTime: '',
        description: '',
        meetingDate: '',
        meetingStartTime: '',
        meetingEndTime: '',
        winner: ''
    });

    // console.log("formData rendered:", formData); // ✅ Debug log

    useEffect(() => {
        GetCpcCasesInfo();
    }, []);

    const checkCpcInProcess = () => {
        if (!resultData?.scheduleDate || !resultData?.meetingDate || !resultData?.meetingEndTime) return;

        const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;

        // ---- START DATETIME (scheduled start) ----
        const startDate = resultData.scheduleDate.split("T")[0]; // "YYYY-MM-DD"
        const [sYear, sMonth, sDay] = startDate.split("-").map(Number);
        const [sHour, sMinute] = resultData.scheduleStartTime.split(":").map(Number);

        const startIST = Date.UTC(sYear, sMonth - 1, sDay, sHour, sMinute);
        const startUTC = startIST - IST_OFFSET_MS;

        // ---- END DATETIME (meeting end) ----
        const endDate = resultData.meetingDate.split("T")[0]; // "YYYY-MM-DD"
        const [eYear, eMonth, eDay] = endDate.split("-").map(Number);
        const [eHour, eMinute] = resultData.meetingEndTime.split(":").map(Number);

        const endIST = Date.UTC(eYear, eMonth - 1, eDay, eHour, eMinute);
        const endUTC = endIST - IST_OFFSET_MS;

        const nowUTC = Date.now();

        console.log("🟢 CPC START (UTC):", new Date(startUTC).toISOString());
        console.log("🔴 CPC END (UTC):", new Date(endUTC).toISOString());
        console.log("🕒 NOW (UTC):", new Date(nowUTC).toISOString());

        const isInProcess = nowUTC >= startUTC && nowUTC <= endUTC;

        console.log("✅ CPC In Process:", isInProcess);

        setIsCpcInProcess(isInProcess);
    };

    useEffect(() => {
        if (resultData?.meetingDate) {
            console.log("🔁 useEffect triggered with resultData:", resultData);

            checkCpcInProcess();

            const interval = setInterval(() => {
                console.log("⏱ Re-checking CPC status...");
                checkCpcInProcess();
            }, 10000);

            return () => {
                console.log("🧹 Clearing interval");
                clearInterval(interval);
            };
        }
    }, [resultData]);

    // console.log('result data', resultData, isCpcInProcess)

    const GetCpcCasesInfo = async () => {
        setIsLoading(true);
        try {
            const response = await tmdbApi.getCPCModules();
            if (response?.result?.data) {
                setCases(response?.result?.data || []);
            }
            setIsLoading(false);
        } catch {
            console.log("error");
            setIsLoading(false);
        }
    };

    // ✅ Load CPC data only once on mount
    useEffect(() => {
        if (cases.length === 0) return; // Wait for cases to load

        if (id && id !== 'new') {
            getCpcInfoById(id);
        } else if (!id && isFirstLoad) {
            getCpcInfoById();
            setIsFirstLoad(false);
        }
    }, [cases.length]); // ✅ Only depends on cases loading


    // console.log('id', id)
    // ✅ NEW: Handle "add new" mode (when id === 'new')
    useEffect(() => {
        if (id === 'new') {
            setIsDataLoaded(true); // ✅ Enable form for new entries
            setActiveCPC(true);
        }
    }, [id]);
    const getCpcInfoById = async (cpcId) => {
        setIsLoading(true);
        setIsDataLoaded(false); // ✅ Mark data as not loaded

        try {
            let response = cpcId ? await tmdbApi.cpcInfoById(cpcId) : await tmdbApi.cpcInfoAdmin("ACTIVE");

            if (typeof response?.result === 'string') {
                // Handle error case
                setActiveCPC(false);
                setIsLoading(false);
                setIsDataLoaded(true);
                return;
            }

            if (response?.result?.length > 0) {
                let formDataTmp = { ...response.result[0] };

                // ✅ Set selected case WITHOUT triggering onChange
                if (formDataTmp?.moduleid && cases.length > 0) {
                    let caseData = cases?.find(c => c.moduleid === formDataTmp.moduleid);
                    if (caseData) {
                        let obj = {
                            value: caseData.moduleid,
                            label: caseData?.name || "no case title"
                        };
                        setSelectedCases([obj]);
                    }
                }

                // ✅ Format scheduleDate properly
                // if (formDataTmp.scheduleDate) {
                //     const scheduleDate = new Date(formDataTmp.scheduleDate);
                //     formDataTmp.scheduleDate = scheduleDate.toISOString().split('T')[0];
                // }

                // ✅ Format scheduleEndDate properly
                // if (formDataTmp.scheduleEndDate) {
                //     const scheduleEndDate = new Date(formDataTmp.scheduleEndDate);
                //     formDataTmp.scheduleEndDate = scheduleEndDate.toISOString().split('T')[0];
                // }

                // ✅ Ensure meetingDate is in correct format
                if (formDataTmp.meetingDate && !formDataTmp.meetingDate.includes('T')) {
                    // Already in YYYY-MM-DD format, keep it
                } else if (formDataTmp.meetingDate) {
                    formDataTmp.meetingDate = new Date(formDataTmp.meetingDate).toISOString().split('T')[0];
                }

                console.log("Loaded formData:", formDataTmp); // ✅ Debug

                setFormData(formDataTmp);
                getParticipantsData(formDataTmp?.cpcid);
                setResultData(formDataTmp);
                setActiveCPC(true);
            } else if (response?.result?.length === 0) {
                setActiveCPC(false);
            }

        } catch (error) {
            console.error("Error loading CPC:", error);
            setActiveCPC(false);
        } finally {
            setIsLoading(false);
            setIsDataLoaded(true); // ✅ Mark data as loaded
        }
    };

    const handleSendMail = async () => {
        if (!formData.cpcid) {
            setMailStatus('Please save the CPC first before sending mail');
            setSuccess(true);
            return;
        }

        setIsLoadingBtn("send mail");
        try {
            const response = await tmdbApi.sendCpcMail({
                cpcId: formData.cpcid,
            });

            if (response.status === 200 || response.statusCode === 200) {
                setMailStatus('Mail sent successfully!');
                setSuccess(true);
            } else {
                throw new Error('Failed to send mail');
            }
        } catch (error) {
            console.error('Mail sending error:', error);

            if (error.code === 'ERR_NETWORK') {
                setMailStatus('Network error: Cannot connect to mail service.');
            } else if (error.response) {
                setMailStatus(`Server error: ${error.response.status} - ${error.response.statusText}`);
            } else {
                setMailStatus('Error sending mail. Please try again.');
            }
            setSuccess(true);
        } finally {
            setIsLoadingBtn("");
        }
    };
    useEffect(() => {
        if (formData.description?.trim()) {
            setErrors(prev => ({
                ...prev,
                description: undefined
            }));
        }
    }, [formData.description]);
    // ✅ Clear specific error when user types
    const handleCChange = (e) => {
        const { name, value } = e.target;

        console.log('name, value', name, value)

        if (["feeprice", "winnerprice"].includes(name)) {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }

        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));

        // ✅ Clear error for this field when user types
        if (hasSubmitted && errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: undefined
            }));
        }
    };

    const [participantsReserved, setParticipantsReserved] = useState([]);
    const getParticipantsData = async (id) => {
        let response = await tmdbApi.participantUsersInfo(id);
        if (typeof response?.result === 'object') {
            setParticipantsReserved(response?.result);
        }
    };

    useEffect(() => {
        if (!formData?.scheduleEndDate) return;

        const endDateTime = new Date(formData.scheduleEndDate);
        const today = new Date();

        setShowButton(today <= endDateTime);
    }, [formData?.scheduleEndDate]);

    const validate = (formData) => {
        const newErrors = {};
        const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;
        console.log('formdata', formData)
        if (!formData.title?.trim()) newErrors.title = 'CPC title is required';
        if (!formData.description?.trim()) newErrors.description = 'Description is required';
        if (!formData.meetingLink?.trim()) newErrors.meetingLink = 'Meeting link is required';

        const link = formData.meetingLink?.trim();

        if (link && !urlPattern.test(link)) {
            newErrors.meetingLink = 'Invalid meeting link format';
        }
        // if (formData.meetingLink?.trim() && !urlPattern.test(formData.meetingLink)) {
        //     newErrors.meetingLink = 'Invalid meeting link format';
        // }

        if (!formData.meetingDate) newErrors.meetingDate = 'Meeting Date is required';
        if (!formData.meetingStartTime) newErrors.meetingStartTime = 'Meeting Start Time is required';
        if (!formData.meetingEndTime) newErrors.meetingEndTime = 'Meeting End Time is required';

        if (formData.meetingStartTime && !isValidTime(formData.meetingStartTime)) {
            newErrors.meetingStartTime = 'Meeting start time must be in HH:mm format';
        }
        if (formData.meetingEndTime && !isValidTime(formData.meetingEndTime)) {
            newErrors.meetingEndTime = 'Meeting end time must be in HH:mm format';
        }

        if (
            !isCpcInProcess &&
            formData.meetingDate &&
            formData.meetingStartTime &&
            isValidTime(formData.meetingStartTime)
        ) {
            const startDateTime = dayjs(`${formData.meetingDate}T${formData.meetingStartTime}`);
            if (!startDateTime.isAfter(dayjs())) {
                newErrors.meetingStartTime = 'Meeting start time must be after current time';
            }
        }

        if (
            formData.meetingStartTime &&
            formData.meetingEndTime &&
            new Date(`1970-01-01T${formData.meetingStartTime}:00`) >=
            new Date(`1970-01-01T${formData.meetingEndTime}:00`)
        ) {
            newErrors.meetingEndTime = 'Meeting end time must be after start time';
        }

        if (formData?.scheduleEndTime) {
            if (formData.scheduleStartTime && !isValidTime(formData.scheduleStartTime)) {
                newErrors.scheduleStartTime = 'Start time must be in HH:mm format';
            }
            if (formData.scheduleEndTime && !isValidTime(formData.scheduleEndTime)) {
                newErrors.scheduleEndTime = 'End time must be in HH:mm format';
            }

            if (
                formData.scheduleDate &&
                formData.scheduleEndDate &&
                new Date(formData.scheduleDate) >= new Date(formData.scheduleEndDate)
            ) {
                newErrors.scheduleEndTime = 'Schedule end time must be after start time';
            }

            if (
                formData.meetingDate &&
                formData.scheduleEndDate &&
                formData.scheduleEndTime &&
                formData.meetingStartTime &&
                isValidTime(formData.scheduleEndTime) &&
                isValidTime(formData.meetingStartTime)
            ) {
                let dt = formData.scheduleEndDate;
                if (formData.scheduleEndDate.includes('T')) {
                    dt = formData.scheduleEndDate.split("T")[0];
                }
                const scheduleEndDateTime = dayjs(`${dt}T${formData.scheduleEndTime}`);
                const meetingStartDateTime = dayjs(`${formData.meetingDate}T${formData.meetingStartTime}`);
                if (!meetingStartDateTime.isAfter(scheduleEndDateTime)) {
                    newErrors.meetingDate = 'Meeting date & time must be after schedule end date & time';
                }
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const setPopupclose = () => {
        setSuccess(false);
        if (upcoming) {
            handleClick();
        }
    };

    const [isDisplay, setIsDisplay] = useState(false);
    const displayParticipants = (type) => {
        setFilterType(type);
        setIsDisplay(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setHasSubmitted(true);

        if (isLoading) return;

        if (!validate(formData)) return;

        setIsLoadingBtn("submit");

        const methodName = formData.cpcid ? "updateCpc" : "addCpc";

        const payload = {
            ...formData,
            meetingLink: formData.meetingLink?.trim(),
            moduleid: selectedCases.length > 0 ? selectedCases[0].value : "",
        };

        try {
            const response = await tmdbApi[methodName](JSON.stringify(payload));

            if (!response?.statusCode) {
                throw new Error("Submission failed");
            }

            setSubmitStatus(response?.result || "Submitted successfully");
            setErrors({});
            setSuccess(true);
        } catch (error) {
            console.error("Submission error:", error);
            setSubmitStatus("Error submitting the form. Try again.");
            setSuccess(false);
        } finally {
            setIsLoadingBtn("");
        }
    };

    // console.log('errors', errors)
    // console.log('formdata', formData)
    const handleChange = (selectedOptions) => {
        if (!selectedOptions) {
            setSelectedCases([]);
            return;
        }

        let selectedModule = cases.find(c => c.moduleid === selectedOptions?.value);

        if (selectedModule) {
            setFormData(prev => ({
                ...prev,
                title: selectedModule?.name,
                description: selectedModule?.description
            }));
        }

        setSelectedCases([selectedOptions]);

        if (hasSubmitted && errors.title) {
            setErrors(prev => ({
                ...prev,
                title: undefined
            }));
        }
    };

    return (
        <>
            <div className="card" id="card">
                <div className="card-body container-fluid" id="card-body">
                    {isLoading ? (
                        <Loader />
                    ) : activeCPC ? (
                        <div>
                            <div className="row">
                                <div className="mb-3 col-12 col-md-6">
                                    <label>Title<span style={{ color: 'red' }}>*</span></label>
                                    {Array.isArray(cases) && (
                                        <Select
                                            value={selectedCases?.[0] || null}
                                            options={cases
                                                .filter((item) => item.name)
                                                .map((item) => ({
                                                    value: item.moduleid,
                                                    label: item.name,
                                                }))
                                            }
                                            name="cases"
                                            onChange={handleChange}
                                            placeholder="Select"
                                            classNamePrefix="my-select"
                                            isDisabled={isCpcInProcess}
                                        />
                                    )}
                                    {hasSubmitted && errors?.title && <div className="text-danger">{errors.title}</div>}
                                </div>
                                <div className="mb-3 col-12 col-md-6">
                                    <label>Meeting Link <span style={{ color: 'red' }}>*</span></label>
                                    <input
                                        type="url"
                                        name="meetingLink"
                                        className="form-control"
                                        value={formData.meetingLink}
                                        onChange={handleCChange}
                                        required
                                    />
                                    {hasSubmitted && errors?.meetingLink && <div className="text-danger">{errors.meetingLink}</div>}
                                </div>
                            </div>

                            <div className="row">
                                <div className="mb-3 col-12">
                                    <label>Description <span style={{ color: 'red' }}>*</span></label>
                                    <Editor name="description" value={formData.description} onChange={handleCChange} disabled={isCpcInProcess} />
                                    {hasSubmitted && errors?.description && <div className="text-danger">{errors.description}</div>}
                                </div>
                            </div>

                            {/* ✅ Only render DatePickers when data is loaded */}
                            {isDataLoaded && formData && (
                                <DateTimeRangePicker24Hr
                                    errors={hasSubmitted ? errors : {}}
                                    formData={formData}
                                    setFormData={setFormData}
                                    IsDisabled={false}
                                />
                            )}

                            <h4 className="mb-3 pt-4 card-title">Pre-CPC Section</h4>
                            <div className="row">
                                <div className="mb-12 col-lg-12 col-12 col-md-12">
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                {/* ✅ Only render DatePickers when data is loaded */}
                                {isDataLoaded && formData && (
                                    <DateTimeRangePicker
                                        formData={formData}
                                        setFormData={setFormData}
                                        IsDisabled={isCpcInProcess && Number(formData?.participatedCount) > 0}
                                    />
                                )}
                                {hasSubmitted && errors?.scheduleEndTime && <div className="text-danger">{errors.scheduleEndTime}</div>}
                            </div>

                            <div className="row">
                                <div className="mb-3 col-md-4">
                                    <label>fee</label>
                                    <input
                                        type="text"
                                        name="cost"
                                        className="form-control"
                                        value={
                                            selectedCases?.length > 0
                                                ? (cases?.find(c => c.moduleid === selectedCases[0].value)?.cost || 0)
                                                : 0
                                        }
                                        required
                                        disabled
                                    />
                                </div>

                                {["ACTIVE"].includes(formData?.meetingStatus) && <div className="mb-3 col-md-4">
                                    <label>Participated Count</label>
                                    <div className="d-flex align-items-center">
                                        <input
                                            type="text"
                                            name="participatedCount"
                                            className="form-control participated-input"
                                            value={formData.participatedCount || 0}
                                            onChange={handleCChange}
                                            required
                                            disabled
                                        />
                                        <a onClick={() => displayParticipants("participated")} className="text-success view-button view-count" style={{ cursor: 'pointer' }}>
                                            <i className="mdi mdi-eye font-size-16"></i>
                                        </a>
                                    </div>
                                </div>
                                }

                                {["ACTIVE"].includes(formData?.meetingStatus) && <div className="mb-3 col-md-4">
                                    <label>Registered Count</label>
                                    <div className="d-flex align-items-center">
                                        <input
                                            type="text"
                                            name="reservedspots"
                                            className="form-control participated-input"
                                            value={formData.reservedspots}
                                            onChange={handleCChange}
                                            required
                                            disabled
                                        />
                                        <a onClick={() => displayParticipants("registered")} className="text-success view-button view-count" style={{ cursor: 'pointer' }}>
                                            <i className="mdi mdi-eye font-size-16"></i>
                                        </a>
                                    </div>
                                </div>}
                            </div>

                            <div className="row">
                                {isCpcInProcess && (
                                    <div className="alert alert-info mt-3">
                                        CPC is currently in process.
                                    </div>
                                )}
                                <div
                                    className="mb-3"
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        gap: "10px",
                                    }}
                                >
                                    <button
                                        type="button"
                                        className="create-quiz-btn border-0 mt-3"
                                        disabled={!!isLoadingBtn}
                                        onClick={handleSubmit}
                                    >
                                        {isLoadingBtn === "submit" && (
                                            <img
                                                src={rotate_right}
                                                className="loading-icon me-2"
                                                alt="loading"
                                            />
                                        )}
                                        {isCpcInProcess ? "Update" : "Submit"}
                                    </button>
                                    {id !== 'new' && !isCpcInProcess && (
                                        <button
                                            type="button"
                                            className="create-quiz-btn border-0 mt-3"
                                            disabled={!!isLoadingBtn}
                                            onClick={handleSendMail}
                                        >
                                            {isLoadingBtn === "send mail" && (
                                                <img
                                                    src={rotate_right}
                                                    className="loading-icon me-2"
                                                    alt="loading"
                                                />
                                            )}
                                            Send Meeting Reminder Email
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="empty-state-body empty-record">
                            <div className="empty-state__message">
                                <span className="material-icons">summarize</span>
                                <p className="form-check font-size-16"><div className="alert alert-warning mt-3">No active CPC is present. Please go to the Upcoming tab and create a new CPC.</div></p>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <SweetAlert
                show={success}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={mailStatus || submitStatus}
                onConfirm={e => setPopupclose(e)}
                id="error-alert"
            ></SweetAlert>

            <Modal show={isDisplay} className="video-popup document-popup cpc-table-popup">
                <button className="close-btn cpc-form-btn" onClick={(e) => setIsDisplay(false)}>
                    <span className="material-icons">close</span>
                </button>
                <Modal.Body>
                    <ParticipantTable participantsReserved={participantsReserved} filterType={filterType} />
                </Modal.Body>
            </Modal>
        </>
    );
}

export default CPCForm;